import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserView } from '../models/userView.model';
import { EndpointService } from './endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class UserViewService extends EndpointService {
  constructor(http: HttpClient) {
    super(http);
  }

  saveDefaultView(payload: UserView): Observable<UserView> {
    return this.http.post<UserView>(this.getApiUrl('UserView/SaveDefaultView'), payload);
  }

  delete(gridId: string): Observable<void> {
    const params = new HttpParams().set('gridId', gridId);
    return this.http.delete<void>(this.getApiUrl('UserView/Delete'), { params });
  }
}